var storefrontApp = angular.module("storefrontApp");
storefrontApp.service('commonService', ['$http', 'configs', function ($http, configs) {
    return {
        formatMoney: function (number, decimalPlaces, decimalSeparator, thousandsSeparator) {
            var n = number,
                c = isNaN(decimalPlaces = Math.abs(decimalPlaces)) ? 2 : decimalPlaces,
                d = decimalSeparator == undefined ? "." : decimalSeparator,
                t = thousandsSeparator == undefined ? "," : thousandsSeparator,
                s = n < 0 ? "-" : "",
                i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
                j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        getCookie: function (key) {
            var cookie = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
            return (cookie ? cookie[2] : null);
        },
        setCookie: function (name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toString();
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        },
        getElasticData: function (baseUrl, request) {
            if (window.__env && window.__env.elasticBaseUrl) {
                configs = window.__env;
            } else {
                console.log("ES not Available. Switching to Defaults");
            }
            return $http({
                method: 'POST',
                url: baseUrl,
                data: request,
                headers: {
                    'Authorization': 'Basic ' + btoa('elasticReadOnly:' + configs.elasticKey),
                }
            }).then(function (response) {
                return response;
            });
        },
        getOrdersLineItemElasticData: function (baseUrl,request) {
            if (window.__env && window.__env.elasticOrdersBaseUrl) {
                configs = window.__env;
            } else {
                console.log("ES not Available. Switching to Defaults");
            }
            return $http({
                method: 'POST',
                url: baseUrl,
                data: request,
                headers: {
                    'Authorization': 'Basic ' + btoa('elasticReadOnly:' + configs.elasticKey),
                }
            }).then(function (response) {
                return response;
            });
        },
        
        getHTMLTextNodes: function (node) {
            var textNodes = [];
            function getTextNodeRecursive(node) {
                if (node.nodeType == 3)
                    new RegExp(/\S/).test(node.nodeValue) && textNodes.push(node);
                else
                    node.childNodes.forEach(function (x) { getTextNodeRecursive(x); });
            }
            getTextNodeRecursive(node);
            return textNodes;
        },
        getStoreAndLocalCurrency: function () {
            return $http.get('storefrontapi/common/storeandlocalcurrency?t=' + new Date().getTime());
        },
        updateRecentlyViewed: function (productId) {
            if (!(angular.isUndefined(productId) || productId == "")) {
                productId = productId.toLowerCase();
                var recentlyViewed = localStorage.getItem('recentlyViewed');
                if (recentlyViewed === null) {
                    localStorage.setItem("recentlyViewed", productId);
                }
                else {
                    recentlyViewed = recentlyViewed.split(',');
                    var index = recentlyViewed.indexOf(productId);
                    if (index !== -1) {
                        recentlyViewed.splice(index, 1);
                    }
                    if (recentlyViewed.length > 11) {
                        recentlyViewed.pop();
                        recentlyViewed.splice(0, 0, productId);
                    }
                    else {
                        recentlyViewed.splice(0, 0, productId);
                    }
                    localStorage.setItem("recentlyViewed", recentlyViewed.toString());
                }
            }
        },
        getMonths: function () {
            return $http.get(
                "storefrontapi/common/months"
            );
        },
        getMachines: function () {
            return $http.get(
                "storefrontapi/common/machines"
            );
        },
        getSoftwares: function () {
            return $http.get(
                "storefrontapi/common/softwares"
            );
        },
        getHoopSizes: function () {
            return $http.get(
                "storefrontapi/common/hoopsizes"
            );
        },
        getIfSuspectUserRestrictionEnabled: function () {
            return $http.get("storefrontapi/common/suspectuserrestrictionenabled");
        },
        getPaymentMethod: function (order) {
            function hasPaymentMethod(value) {
                return paymentMethod.indexOf(value) > -1;
            }
            var paymentMethod = [];
            if (order.total.amount == 0) {
                paymentMethod.push("Free Order");
            }
            else if (order.total.amount > 0 && angular.isDefined(order.inPayments) && order.inPayments.length > 0) {
                order.inPayments.forEach(function (p, index) {
                    if (p.transactionType && (p.transactionType.toLowerCase() == 'sale' || p.transactionType.toLowerCase() == 'authorize')) {
                        if (p.gatewayCode == "Paypal.DirectPayment") {
                            if (angular.isDefined(p.creditCardType) && !hasPaymentMethod(p.creditCardType)) {
                                paymentMethod.push(p.creditCardType);
                            }
                        }
                        else if (p.gatewayCode == "Paypal.ExpressCheckout" && !hasPaymentMethod("Paypal Payment")) {
                            paymentMethod.push("Paypal Payment");
                        }
                        else if (p.gatewayCode == "GiftCardPayments" && !hasPaymentMethod("GiftCard Payment")) {
                            paymentMethod.push("GiftCard Payment");
                        }
                    }
                });
            }
            return (paymentMethod.length < 1 ? "N/A" : paymentMethod.join("<br/>"))
        },
        validateCardExpiryDate: function (expYear, expMonth) {
            var isValid = false;
            if (angular.isDefined(expYear) && angular.isDefined(expMonth)) {
                var currentYear = new Date().getFullYear();
                var currentMonth = new Date().getMonth() + 1;
                isValid = ((expYear < currentYear) || (expYear == currentYear) && (expMonth < currentMonth));
            }
            return isValid;
        },
        getProductsInventory: function (productId) {
            return $http.get(
                'storefrontapi/product/inventories?t=' + new Date().getTime(),
                { params: { "productIds": productId } }
            );
        },
        hasInventory: function (productId) {
            return $http.get('storefrontapi/product/inventory/' + productId);
        },
        getTop5Products: function (topProducts) {
            return $http.post('storefrontapi/product/gettopproducts', topProducts);
        },
        getGDPRExpiration: function () {
            return $http.get('storefrontapi/getgdprexpiration');
        },
        getComboSaleSettings: function(productId, definitionName, vendorId, variants){

            return $http.post("storefrontapi/product/getcombosalesettings", {
                itemId: productId,
                definitionName: definitionName,
                catalogId: vendorId,
                variants: variants
            });

        },

        checkAdExpiry : function (value){
            var currentDate = window.currentDate.toString().match(/\d{1,2}\/\d{1,2}\/\d{4}/)[0];
            var regexValues = value.match(/\d{1,2}\/\d{1,2}\/\d{4}/);
            if(regexValues != null)
            {
                var storedDate = regexValues[0];
                if(storedDate == currentDate)
                {
                    return true
                }
                return false;
            }
        },
        getFrequentlyBoughtProducts: function (itemId,catalog) {
            return $http.get(
                "storefrontapi/getboughttogetheritems?itemId=" + itemId + "&vendor=" + catalog
            );
        },
        getModuleKeys: function (key) {
                return $http.get("storefrontapi/modulekeys?key=" + key);
        },
    }
}]);

storefrontApp.service("modalService", function () {
    var modals = [];
    var service = {};

    service.add = add;
    service.remove = remove;
    service.open = open;
    service.close = close;

    function add(modal) {
        modals.push(modal);
    }

    function remove(id) {
        var modalToRemove = _.findWhere(modals, { id: id });
        modals = _.without(modals, modalToRemove);
    }

    function open(id) {
        var modal = _.findWhere(modals, { id: id });
        modal && modal.open();
    }

    function close(id) {
        var modal = _.findWhere(modals, { id: id });
        modal && modal.close();
    }

    return service;
});
